export const MIN_BUILDING_CONSTRUCTION_YEAR = 1950;
export const MAX_PROJECTS_LIMIT = 2000;
